<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" alt="logo"></a>
                    <p style="margin-top:-10px">fornisce un servizio completo, che va dal supporto tecnico-ingegneristico fino ai corsi di formazione e informazione in materia di sicurezza sul lavoro, green economy, qualità e ambiente. In tema di formazione propone un corso per progettisti di impianti fotovoltaici.</p>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/scuoladiformazionesangiuseppe/" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://instagram.com/scuolasangiuseppemoscati?igshid=YmMyMTA2M2Y=" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Link</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Login</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Discenti</a></li>
                        <li><a href="https://discentya.biessesolution.com/login.php" target="_blank">Docenti</a></li>
                        <li><a href="https://discentya.biessesolution.com/login.php" target="_blank">Partners</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Dove Siamo</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Viale A. La Falce, 85<br>87040 San Lorenzo del Vallo (CS) - Italia</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+3909811848023">Telefono: (+39) 0981-1848023</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:iscrizioni@corsinapoli.com">iscrizioni@corsinapoli.com</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+3909811848023">Lunedì-Venerdì: 09:00 ÷ 18:00</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2023 Biesse Solution - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2">
                    <ul>
                        <li><a routerLink="/privacy-policy">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
